import React, { type FunctionComponent, Suspense } from 'react';

import styled from 'styled-components';

import { Loader } from '@sine/sine-ui-components';

const StyledLoader = styled(Loader)`
  position: absolute;
`;

export default function wrapLazyLoad<T>(LazyComponent: FunctionComponent<T>): FunctionComponent<T> {
  const WrappedLazyComponent: FunctionComponent<T> = (props) => (
    <Suspense fallback={<StyledLoader show fillAndCenter />}>
      <LazyComponent {...(props as any)} />
    </Suspense>
  );

  const lazyComponentName = LazyComponent.displayName || LazyComponent.name || 'LazyComponent';
  WrappedLazyComponent.displayName = `LazyLoad(${lazyComponentName})`;

  return WrappedLazyComponent;
}
